import React from 'react'
import { useEffect } from 'react'
import Header from '../common/Header'
import SideMenu from '../common/SideMenu'
import Tr from './Tr';

import './DrawTransactions.css'
import { useTranslation } from "react-i18next";
import { fetchDrawTransactions } from '../../../utils/apiClient';

/**
 * 抽卡交易（draw_transactions）管理画面。#57
 * 決済番号 / 注文番号 / ユーザーID / 状態で検索し、問合せ・サポート対応に使う。
 * 一覧は1ページ100件でページング。状態は varchar のため cancelled も表示対象。
 */
const PER_PAGE = 100;

const DrawTransactions = () => {
  const { t } = useTranslation();

  const [list, setList] = React.useState([]);
  const [count, setCount] = React.useState(0);
  const [offset, setOffset] = React.useState(0);

  const [state, setState] = React.useState('');
  const [orderNo, setOrderNo] = React.useState('');
  const [userId, setUserId] = React.useState('');
  const [wechatTxId, setWechatTxId] = React.useState('');

  useEffect(() => {
    const api = () => {
      const params = new URLSearchParams();
      if (state) params.append('state', state);
      if (orderNo) params.append('order_no', orderNo);
      if (userId) params.append('user_id', userId);
      if (wechatTxId) params.append('wechat_transaction_id', wechatTxId);
      params.append('offset', offset);

      fetchDrawTransactions(params.toString())
        .then(async response => {
          const data = await response.json().catch(() => ({}));
          if (!response.ok) {
            alert(data.message || t('common.error'));
            return;
          }
          if (data?.errors) {
            alert(Object.values(data.errors)[0]);
            return;
          }
          setList(data?.data || []);
          setCount(data?.meta?.count ?? (data?.data?.length || 0));
        })
        .catch(error => {
          console.error(error);
        });
    }

    const timer = setTimeout(() => { api(); }, 400)
    return () => clearTimeout(timer)
  }, [state, orderNo, userId, wechatTxId, offset]);

  // 検索条件を変えたら先頭ページへ
  const onFilterChange = (setter) => (e) => { setter(e.target.value); setOffset(0); };

  const changeOffset = (next) => {
    if (next < 0) next = 0;
    if (next >= count) next = Math.max(0, Math.floor((count - 1) / PER_PAGE) * PER_PAGE);
    setOffset(next);
  }

  const CreateList = () => {
    return list.map((tx, index) => <Tr key={index} tx={tx} />)
  }

  return (
    <>
      <Header />
      <SideMenu />
      <div className="draw-transactions">
        <div className="draw-transactions-title">{t('draw_transactions.title')}</div>
        <div className='clearfix'></div>

        <div className="draw-transactions-search">
          <table className="draw-transactions-search-table">
            <tbody>
              <tr>
                <td>
                  <select className="draw-transactions-search-input" value={state} onChange={onFilterChange(setState)}>
                    <option value="">{t('draw_transactions.state_all')}</option>
                    <option value="pending_payment">{t('draw_transactions.state_pending_payment')}</option>
                    <option value="confirmed">{t('draw_transactions.state_confirmed')}</option>
                    <option value="oversold">{t('draw_transactions.state_oversold')}</option>
                    <option value="failed">{t('draw_transactions.state_failed')}</option>
                    <option value="cancelled">{t('draw_transactions.state_cancelled')}</option>
                  </select>
                </td>
                <td>
                  <input className="draw-transactions-search-input" type="text" placeholder={t('draw_transactions.order_no')} value={orderNo} onChange={onFilterChange(setOrderNo)} />
                </td>
                <td>
                  <input className="draw-transactions-search-input" type="text" placeholder={t('draw_transactions.user_id')} value={userId} onChange={onFilterChange(setUserId)} />
                </td>
                <td>
                  <input className="draw-transactions-search-input" type="text" placeholder={t('draw_transactions.wechat_transaction_id')} value={wechatTxId} onChange={onFilterChange(setWechatTxId)} />
                </td>
              </tr>
            </tbody>
          </table>
          <div className="draw-transactions-count">{t('draw_transactions.count')}: {count}</div>
        </div>

        <div className="draw-transactions-paging">
          <button className="draw-transactions-paging-prev-button draw-transactions-paging-button" onClick={() => changeOffset(offset - PER_PAGE)}>{t('user.prev')}</button>
          <div className="draw-transactions-paging-text">{count === 0 ? 0 : offset + 1} - {offset + PER_PAGE > count ? count : offset + PER_PAGE} / {count}</div>
          <button className="draw-transactions-paging-next-button draw-transactions-paging-button" onClick={() => changeOffset(offset + PER_PAGE)}>{t('user.next')}</button>
        </div>

        <div className="draw-transactions-content">
          <table className="draw-transactions-content-table">
            <thead>
              <tr>
                <th>{t('draw_transactions.order_no')}</th>
                <th>{t('draw_transactions.package')}</th>
                <th>{t('draw_transactions.user_id')}</th>
                <th>{t('draw_transactions.state')}</th>
                <th>{t('draw_transactions.total_pt')}</th>
                <th>{t('draw_transactions.consumed_pt')}</th>
                <th>{t('draw_transactions.cash_paid_cny')}</th>
                <th>{t('draw_transactions.rate')}</th>
                <th>{t('draw_transactions.refund_state')}</th>
                <th>{t('draw_transactions.wechat_transaction_id')}</th>
                <th>{t('draw_transactions.created_at')}</th>
              </tr>
            </thead>
            <tbody>
              <CreateList />
            </tbody>
          </table>
        </div>
      </div>
    </>
  )
}

export default DrawTransactions
